import React from 'react';
import { Button } from '../../../components/ui/button';
import { Card, CardContent } from '../../../components/ui/card';
import { ArrowLeft, Save } from 'lucide-react';

// Enveloppe d'une page de saisie de la journée : retour au menu + sauvegarde
export const PageShell = ({ title, icon: Icon, onBack, onSave, saving, canEdit, actions, children, testId }) => (
  <Card data-testid={testId}>
    <CardContent className="p-4 space-y-4">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-3">
          <Button type="button" variant="ghost" size="sm" onClick={onBack} data-testid="btn-back-menu-journee">
            <ArrowLeft className="w-4 h-4 mr-1" /> Menu de la journée
          </Button>
          <h3 className="text-sm font-semibold text-slate-800 flex items-center gap-2">{Icon && <Icon className="w-4 h-4 text-indigo-500" />} {title}</h3>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          {actions}
          {canEdit && onSave && (
            <Button type="button" size="sm" onClick={() => onSave()} disabled={saving} className="bg-indigo-600 hover:bg-indigo-700" data-testid="btn-save-page-journee">
              <Save className="w-3.5 h-3.5 mr-1" /> {saving ? 'Sauvegarde…' : 'Enregistrer'}
            </Button>
          )}
        </div>
      </div>
      {children}
    </CardContent>
  </Card>
);
